import React, { useEffect, useState, } from "react";
import style from "./proReportShow.module.scss";
import Searchbar from "../productSearchbar/productSearchbar"
import Pagination from "../pagination/pagination"
import toPersianNumber from '../../helpers/actions/toPersianNumber'
import TinyDropdown from "../Dropdown/tinyDropdown/tinyDropdown";
import Button from "../Button/button"
import ProReportCard from "./proReportCard/proReportCard"
import OrderDetailModal from "./orderDetailModal/orderDetailModal"
import { GenerateProReport, GetReportDetails, GetBrands, GetproductGroup, GetSellers } from "../../actions/APIcalls"
import { serverAddress } from "../../helpers/axiosFiles/axios";
import { withRouter, Link } from "react-router-dom";
import Dropdown from "../Dropdown/ButtonDropDown/DropDown";
import EditModal2 from "../pricing/editModal/EditModal2"
import CalendarModal from "../modalCalendar/modalCalendar";
import momentJalaali from 'moment-jalaali';
import GradientToast from "../gradientToast/Toast"
import SortFilterButton from "../sortFilterButton/sortFilterButton";
import Skeleton from "./skeleton"
import ReportCharts from './proReportCharts/proReportChart'

const SortFilterButtonValues = [{ label: 'تعداد مرجوعی', value: 'return' }, { label: 'درصد مرجوعی', value: 'returnPercent' }]
const previewFilterButtonValue = [{ label: 'نمودار', value: 'graph' }, { label: 'جدول', value: 'table' }]

const ProReportShow = (props) => {
    const [hasSkeleton, setHasSkeleton] = useState(true)
    const [search, setSearch] = useState('');
    const [pageData, setPageData] = useState({ pageCount: 1, currentPage: 1, countInPage: 10, resultCount: 0 })
    const [list, setList] = useState([])
    const [listDetail, setListDetail] = useState({ list: [], showModal: false, selectedData: {} })
    const [filterData, setFilterData] = useState({ brands: [], productGroups: [], channels: [], dateRange: {} });
    const [editList, setEditList] = useState([])
    const [editModalData, setEditModalData] = useState({ show: false, commission: "", showConfirmButton: false })
    const [dateRangeLabel, setDateRangeLabel] = useState('هفته اخیر')
    const [openCalendarModal, setOpenCalendarModal] = useState(false)
    //lifecyles*************************************************
    useEffect(() => {
        window.addEventListener('popstate', () => {
            // setSearch("")
        })
        return () => window.removeEventListener('popstate', () => {
        })
    }, [])

    useEffect(async () => {
        getFilterData()
        if (typeof props.location !== "undefined" && typeof props.location.search !== "undefined" && props.location.search !== "") {
            let url = new URLSearchParams(window.location.search);
            url.get("search") && await setSearch(url.get("search"));
        }
        getList()
    }, [props.location])

    // if on top set navbar to fix 
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    // end

    //Get Data from server *************************************
    const getList = async () => {
        setHasSkeleton(true)
        let params = {
            query: {
                page: getFromUrl('page') ? Number(getFromUrl('page')) : pageData.currentPage,
                pageCount: pageData.pageCount,
                pageNumber: (getFromUrl('previewBy') == 'table' ? (getFromUrl('countInPage') ? Number(getFromUrl('countInPage')) : Number(pageData.countInPage)) : 10000000),
                search: search,
                brand: getFromUrl("brand"),
                channel: getFromUrl("channel"),
                productGroup: getFromUrl("productGroup"),
                date: {
                    from: getFromUrl("from"),
                    to: getFromUrl("to"),
                },
                orderBy: props.location.state && props.location.state.report && props.location.state.report.orderedBy
            },
            name: props.location.state && props.location.state.report && props.location.state.report.englishName
        }
        props.location.state && props.location.state.report && props.location.state.report.type === "returned" && (params.query.sortBy = getFromUrl('sortBy'));
        let res = await GenerateProReport(params)
        if (typeof res !== "undefined") {
            setList(res.data.result)
            let page = pageData
            page.pageCount = res.data.pageCount
            page.resultCount = res.data.pageNumber
            page.countInPage = (getFromUrl('previewBy') == 'table' ? (getFromUrl('countInPage') ? Number(getFromUrl('countInPage')) : 10) : 10000000)
            setPageData({ ...page })
        }
        setHasSkeleton(false)
        await getProReportDetails(params)
    }

    const getProReportDetails = async (params) => {
        let res = await GetReportDetails(params)
        let tmp = listDetail
        if (res && res.data && res.data.data) {
            tmp.list = res.data.data
        }
        setListDetail({ ...tmp })
    }

    const getFilterData = async () => {
        const resBrands = await GetBrands(openToast);
        const resChannels = await GetSellers(openToast);
        const resGroupProduct = await GetproductGroup(openToast);
        setFilterData({
            brands: urlChecker(resBrands.data.BrandList, "brand"),
            productGroups: urlChecker(resGroupProduct.data.GroupList, "productGroup"),
            channels: resChannels.data.channelList,
        })
        if (props.location.state && props.location.state.report && props.location.state.report.type === "returned") {
            let url = getFromUrl('sortBy');
            if (typeof url === 'undefined') {
                setToUrl('returnPercent', 'sortBy');

            }
        } else {
            let url = getFromUrl('previewBy');
            if (typeof url === 'undefined') {
                setToUrl('table', 'previewBy');
            }
        }
    }

    //handlers**************************************************
    const searchHandler = (tag, val) => {
        if (tag === "clear") {
            setSearch("")
        } else {
            if (val === "") {
                props.history.push(
                    './' + `${props.location.state.report._id}`,
                    { search: val, id: props.location.state.report._id, report: { ...props.location.state.report } }
                );
            } else {

                props.history.push(
                    './' + `${props.location.state.report._id}` + "?search=" + val,
                    { search: val, id: props.location.state.report._id, report: { ...props.location.state.report } }
                );
            }
            setSearch(val);
            getList()
        }
    }
    const openEditModal = (productId) => {
        let temp = { ...editModalData }
        temp.show = true
        setEditModalData({ ...temp })
        let product = list.find(item => item._id === productId)
        if (product) {
            let array = []
            array.push(product.product[0])
            setEditList([...array])
        }
        // getSingleData(productId)
    }
    const deleteFromUrl = (param) => {
        let url = new URLSearchParams(window.location.search);
        url.delete(param);
        props.history.push({
            pathname: window.location.pathname + "?" + url.toString(),
            state: { ...props.location.state }
        });
        let filterDataTemp = { ...filterData };
        filterDataTemp[`${param}s`] = urlChecker(filterDataTemp[`${param}s`], param);
        setFilterData(filterDataTemp);
    }
    const searcher = (searchlist, key) => {
        let searchedList = []
        if (key) {
            searchlist.map(item => {
                if (item.name.includes(key)) {
                    searchedList.push(item);
                }
            })
            return searchedList;
        } else {
            return searchlist;
        }
    }
    const selectHandler = (tag, value) => {
        let filterDataTemp = { ...filterData };
        let url = getFromUrl(tag);
        if (value.checked) {
            url.splice(url.indexOf(tag === "channel" ? value._id : value.name), 1);
        } else {
            url.push(tag === "channel" ? value._id : value.name ? value.name : value)
        }
        setToUrl(url, tag);
        filterDataTemp[`${tag}s`] = urlChecker(filterDataTemp[`${tag}s`], tag);
        setFilterData(filterDataTemp);

    }
    const sortHandler = (tag, value) => {
        let filterDataTemp = { ...filterData };
        let url = getFromUrl(tag);
        console.log(url);
        if (url !== value) {
            setToUrl(value, tag);
            filterDataTemp[tag] = value;
            setFilterData(filterDataTemp);
        }
    }
    const setDateRange = (range) => {
        let urlFrom = getFromUrl("from");
        let urlTo = getFromUrl("to");
        range.start && (urlFrom = momentJalaali(range.start))
        range.end && (urlTo = momentJalaali(range.end))
        setToUrl(urlFrom, "from");
        setToUrl(urlTo, "to");
        getList()
    }
    const pageSetter = (number) => {
        let data = pageData
        data.currentPage = number
        setPageData({ ...data })
        setToUrl(number, 'page')
    }
    const closeModalHandler = (value) => {
        if (value) {
            let modal = editModalData
            modal.show = false;
            setEditModalData({ ...modal })
        }
    }
    //functions*****************************************
    const openToast = (error) => {
        let editVaraintTemp = { ...editList };
        editVaraintTemp.toast = error;
        setEditList(editVaraintTemp);
    }
    const setToUrl = (value, param) => {
        let url = new URLSearchParams(window.location.search);

        if (Array.isArray(value)) {
            let tempString = "";
            value.map(item => {
                tempString ? tempString = `${tempString}*${item}` : tempString = item;
            })
            url.set(param, tempString);
        } else {
            url.set(param, value);
        }
        props.history.push({
            pathname: window.location.pathname + "?" + url.toString(),
            state: { ...props.location.state }
        });
        if (param != "salesStatus" && param != "productGroup" && param != "brand" && param != "channel" && param != "from" && param != "to") {
            console.log(param, 'param');
            getList();
        }
    }
    const urlChecker = (list, key) => {
        let tempList = [];
        let filters = getFromUrl(key);
        switch (key) {
            case "channel":
                // list.map(item => {
                //     if (filters.indexOf(item.name ? item.name : item) >= 0) {
                //         tempList.push({ name: item.name ? item.name : item, checked: true });
                //     } else {
                //         tempList.push({ name: item.name ? item.name : item, checked: false });
                //     }
                // })

                list.map(item => {
                    if (filters.indexOf(item._id ? item._id : item) >= 0) {
                        console.log("hey ");
                        tempList.push({ name: item.name ? item.name : item, _id: item._id, checked: true });
                    } else {
                        tempList.push({ name: item.name ? item.name : item, _id: item._id, checked: false });
                    }
                })
                break;
            case "brand":
                list.map(item => {
                    if (filters.indexOf(item.name ? item.name : item) >= 0) {
                        tempList.push({ name: item.name ? item.name : item, checked: true });
                    } else {
                        tempList.push({ name: item.name ? item.name : item, checked: false });
                    }
                })
                break;
            case "productGroup":
                list.map(item => {
                    if (filters.indexOf(item.name ? item.name : item) >= 0) {
                        tempList.push({ name: item.name ? item.name : item, checked: true });
                    } else {
                        tempList.push({ name: item.name ? item.name : item, checked: false });
                    }
                })
                break;
            default:
                break;
        }
        return tempList;
    }
    const getFromUrl = (param) => {
        const defaultParams = {
            brand: [],
            channel: [],
            productGroup: [],
            countInPage: 10,
            page: 1,
            query: "",
            from: momentJalaali().subtract(7, "day"),
            to: momentJalaali(),
            previewBy: 'table'
        }
        let url = new URLSearchParams(window.location.search);
        if (url.get(param)) {
            if (param === "brand" || param === "productGroup" || param === "channel") {
                return url.get(param).split("*");
            } else {
                if (url.get(param) === "true" || url.get(param) === "false") {
                    return url.get(param) === "true" ? true : false;
                } else {

                    return url.get(param)
                }
            }
        } else {
            return defaultParams[param];
        }
    }

    const createExcel = async () => {
        let params = {
            query: {
                page: pageData.currentPage,
                pageCount: pageData.pageCount,
                pageNumber: Number(pageData.countInPage),
                search: search,
                brand: getFromUrl("brand"),
                channel: getFromUrl("channel"),
                productGroup: getFromUrl("productGroup"),
                date: {
                    from: getFromUrl("from"),
                    to: getFromUrl("to"),
                },
                orderBy: props.location.state && props.location.state.report && props.location.state.report.orderedBy
            },
            name: props.location.state && props.location.state.report && props.location.state.report.englishName,
            createExcel: true
        }
        let res = await GenerateProReport(params)

        if (res && res.data) {
            window.location.href = serverAddress + "getFiles/uploads/" + res.data.fileName
        }
    }

    const createGrapghList = (list, type) => {
        let result = []
        if (type != '') {
            list.map(el => {
                let dummyObject = {
                    label: ((el.product[0].name).split(" | ")[0]).substr(0, 12) + '...',
                    data: (type.type == 'sell' ? parseInt(el.count) : parseInt(el.profit)),
                }
                result.push(dummyObject)
            })
        }
        return result
    }

    const toggleReportDetail = id => {
        let tmp = listDetail
        if (typeof id != 'undefined') {
            tmp.showModal = true
            tmp.selectedData = listDetail.list.filter(el => el._id == id)[0]
        }
        setListDetail({ ...tmp })
    }

    if (hasSkeleton) {
        return <Skeleton />
    } else {
        return (
            <div className={style.wrapper}>
                {
                    props.user.expiredAccount &&
                    <div className={style.gradientWrapper}>
                        <GradientToast tag="test" value={true}>
                            <>
                                <p className={style.expiredTitle}>شارژ کیف پول شما تمام شده‌است.</p>
                                <p className={style.expiredText}>برای فعال‌سازی مجدد ربات، کیف پول خود را شارژ کنید.</p>
                                <Link className={style.expiredLink} to={'/chargewallet'}>ورود به صفحه‌ی  شارژ کیف پول  </Link>
                            </>
                        </GradientToast>
                    </div>
                }
                <EditModal2
                    list={editList}
                    show={editModalData.show}
                    closeModal={closeModalHandler}
                />
                <OrderDetailModal
                    data={listDetail.selectedData}
                    show={listDetail.showModal}
                    closeModal={() => setListDetail({ ...listDetail, showModal: false })}
                />
                <div className={style.returnRow}>
                    <div className={style.backButton} onClick={() => {
                        props.history.push("../proreportlist")
                    }}>
                        بازگشت
                        <span>c</span>
                    </div>
                </div>
                <div className={style.headerWrapper}>
                    <h3> گزارش
                        پیشرفته {(props.location.state && typeof props.location.state.report !== "undefined") ? props.location.state.report.name : ''}</h3>
                    <div className={style.buttonWrapper}>
                        <Button
                            disabled={false}
                            tag="cancelUpdate"
                            type="solid"
                            label="دانلود فایل اکسل گزارش"
                            onclick={() => { props.location.state && typeof props.location.state.report !== "undefined" ? createExcel() : console.log('') }} />
                    </div>
                </div>
                {
                    props.location.state && props.location.state.report && props.location.state.report.englishName === "returned" &&
                    <div className={style.warningContainer}>
                        <div className={style.returnedWraning}>
                            <div className={style.icon}>h</div>
                            <div className={style.text}>با توجه به قوانین دیجی‌کالا، لیست محصولات مرجوعی حداکثر تا ۱۵ روز
                                (مهلت اعلام مرجوعی خریدار) اعلام می‌شود.
                            </div>
                        </div>
                    </div>
                }
                {/* <div className={style.content}> */}
                {/* {props.location.state.report && props.location.state.report.englishName !== "returned" && list.length > 0 &&    */}
                <React.Fragment>
                    <div className={style.searchbarWrapper}>
                        <Searchbar
                            placeholder={"عنوان یا کد کالا یا کد تنوع"}
                            value={search}
                            searchValue={(value) => searchHandler("add", value)}
                            clear={() => searchHandler("clear")}
                        />
                    </div>
                    <div className={style.cardComponents}>
                        <div className={style.filterRow}>
                            <CalendarModal
                                label={dateRangeLabel}
                                dateLabel={(label) => {
                                    setDateRangeLabel(label)
                                }}
                                setRange={(range) => {
                                    setDateRange(range)
                                }}
                                value={{ start: getFromUrl("from"), end: getFromUrl("to") }}
                                openModal={openCalendarModal}
                            />
                            <div className={style.dropdownBox}>
                                <Dropdown
                                    tag='productGroup'
                                    label='گروه محصول'
                                    placeHolder='گروه محصول'
                                    dropdownList={searcher(filterData.productGroups, filterData.productGroup)}
                                    hasSearchBox={true}
                                    hasCheckbox={true}
                                    handleSearch={searchHandler}
                                    deleteSelectedItems={deleteFromUrl}
                                    handleSelect={selectHandler}
                                    action={getList} />
                            </div>
                            <div className={style.dropdownBox}>
                                <Dropdown
                                    tag='brand'
                                    label='برند'
                                    placeHolder='برند'
                                    dropdownList={searcher(filterData.brands, filterData.brand)}
                                    hasSearchBox={true}
                                    hasCheckbox={true}
                                    handleSearch={searchHandler}
                                    deleteSelectedItems={deleteFromUrl}
                                    handleSelect={selectHandler}
                                    action={getList} />
                            </div>
                            {filterData.channels.length > 0 &&
                                <div className={style.dropdownBox}>
                                    <Dropdown
                                        tag='channel'
                                        label='فروشنده'
                                        placeHolder='فروشنده'
                                        dropdownList={filterData.channels}
                                        hasSearchBox={true}
                                        hasCheckbox={true}
                                        handleSearch={searchHandler}
                                        deleteSelectedItems={() => deleteFromUrl("seller")}
                                        handleSelect={selectHandler}
                                        action={getList}
                                    />
                                </div>
                            }
                        </div>
                        {props.location.state && props.location.state.report && props.location.state.report.type === "returned" &&
                            <div className={style.filterRow}>
                                <SortFilterButton
                                    tag="sortBy"
                                    label=':مرتب‌سازی بر اساس'
                                    filters={[...SortFilterButtonValues]}
                                    selected={getFromUrl('sortBy')}
                                    onclick={sortHandler}
                                />
                            </div>
                        }

                        {props.location.state && props.location.state.report && props.location.state.report.type !== "returned" &&
                            <div className={style.filterRow}>
                                <SortFilterButton
                                    tag="previewBy"
                                    label=':نمایش بر اساس'
                                    filters={[...previewFilterButtonValue]}
                                    selected={getFromUrl('previewBy')}
                                    onclick={sortHandler}
                                />
                            </div>
                        }
                    </div>
                </React.Fragment>
                {/* } */}
                {(list.length > 0 && getFromUrl('previewBy') == 'table') &&
                    <div className={style.pagination}>
                        <div className={style.Dropdown}>
                            <Pagination
                                currentPage={pageData.currentPage}
                                pageCount={pageData.pageCount}
                                setPage={pageSetter}
                            />
                            <TinyDropdown
                                placeholder={getFromUrl('countInPage') ? getFromUrl('countInPage') : pageData.countInPage}
                                dropdownList={["10", "25", "50", "75", "100"]}
                                selected={selected => {
                                    let page = pageData;
                                    page.countInPage = selected;
                                    setPageData({ ...page })
                                    setToUrl(selected, 'countInPage')
                                }} />
                            <div className={style.label}>تعداد نمایش در صفحه</div>
                            <div className={style.verticalLine}></div>
                            <div className={style.variantCount}>{toPersianNumber(pageData.resultCount) + " تنوع"}</div>
                        </div>
                    </div>}
                {list.length > 0 ?
                    <div className={style.newListWrapper}>
                        {getFromUrl('previewBy') == 'table' ?
                            <>
                                {/* table */}
                                {list.length > 0 && <div className={style.hiddenListShadow}></div>}
                                <div className={style.listWrapper} style={list.length < 1 ? { overflowX: 'hidden' } : null}>
                                    {list.length > 0 && <>
                                        <div
                                            style={offset > 580 && (sessionStorage.getItem("sideBarOpen") && sessionStorage.getItem("sideBarOpen") == 'false') ? { width: 'calc(100% - 140px)' } : (offset > 580 ? { width: 'calc(100% - 280px)' } : null)}
                                            className={offset > 580 ? style.listHeaderShadowFixed : style.listHeaderShadow}>
                                            <div className={style.listHeader}>
                                                <div className={style.listHeaderFlexItem303}>مشخصات کالا</div>
                                                <div className={style.listHeaderFlexItem42}>تعداد فروش</div>
                                                {props.location.state && props.location.state.report && props.location.state.report.type === "returned" && <div className={style.listHeaderFlexItem42}>تعداد مرجوعی</div>}
                                                < div className={style.listHeaderItems}>جمع مبلغ فروش<span>(ریال)</span></div>
                                                <div className={style.listHeaderItems}>سود شما<span>(ریال)</span></div>
                                                <div className={style.listHeaderItems}></div>
                                                <div className={style.listHeaderFlexItem32noMargin}></div>
                                            </div>
                                        </div>
                                        <div className={style.listHeader}></div>
                                    </>}

                                    <div className={style.mainListFrame}>
                                        {list.length > 0 &&
                                            list.map((item, index) => {
                                                return <div className={style.list} key={index}>
                                                    <ProReportCard
                                                        type={props.location.state && props.location.state.report && props.location.state.report.type === "returned" ? "returned" : "sell"}
                                                        data={item}
                                                        reportName={props.location.state && props.location.state.report && props.location.state.report.englishName}
                                                        threeDotHandler={openEditModal}
                                                        toggleReportDetail={toggleReportDetail}
                                                    />
                                                </div>
                                            })
                                        }
                                    </div>
                                </div>
                            </>
                            :
                            <>
                                {/* graph */}
                                <ReportCharts
                                    tag='ReportCharts'
                                    data={createGrapghList(list, (props.location.state && props.location.state.report ? props.location.state.report : ''))}
                                />
                            </>
                        }
                    </div>
                    :
                    (props.location.state && props.location.state.report && props.location.state.report.englishName === "returned" ?
                        <div className={style.emptyListContainer}>
                            <div className={style.icon}>P</div>
                            <p className={style.text}>.با توجه به قوانین دیجی‌کالا، لیست محصولات مرجوعی حداکثر تا ۱۵ روز
                                (مهلت اعلام مرجوعی خریدار) اعلام می‌شود</p>
                            <div className={style.button}>
                                <Button type="solid" label="تغییر تاریخ" onclick={() => {
                                    setOpenCalendarModal(true)
                                }} />
                            </div>
                        </div>
                        :
                        <div className={style.empty}>
                            <div className={style.noResultInSearchImage}></div>
                            <p className={style.boldText}>کاربر عزیز،
                                گزارش
                                {" "}{props.location.state && typeof props.location.state.report !== "undefined" && props.location.state.report.name}{" "}
                                با فیلترهای انتخابی هیچ نتیجه‌ای نداشت.</p>
                            <div className={style.buttonPack}>
                                <Button type="solid"
                                    label={"مشاهده لیست گزارشات پیشرفته"}
                                    onclick={() => props.history.push("/report/proreportlist")}
                                />
                            </div>
                        </div>
                    )
                }

                {
                    (list.length > 0 && getFromUrl('previewBy') == 'table') && <div className={style.paginationTwo}>
                        <Pagination currentPage={pageData.currentPage} pageCount={pageData.pageCount} setPage={pageSetter} />
                    </div>
                }
                {/* </div> */}
            </div >
        )
    }
}

export default withRouter(ProReportShow);
